import React from 'react'
import {subfinder,tcp,udp,sql,url,dig,whatweb,nuclei,blog04} from './imports';
import '../style/tools.css'

const ToolsCard = ({imgUrl,heading,data,btn}) => (
    <div className="scannel-container_tools">
        <div className="scannel__container_tools-image">
            <img src={imgUrl} alt="blog_image" />
        </div>
        <div className="scannel__container_tools-content">
            <div>
                <h1>{heading}</h1>
                <h3>{data}</h3>
            </div>
            <p  >scan</p>
        </div>
    </div>
)



function Tools() {
  return (
    <div className="scannel_tools section__padding" id="Tools">
    <div className="scannel_tools-heading">
      <h1 className="gradient__text">A lot is happening, <br /> We are concerning about it.</h1>
    </div>
    <div className="scannel_tools-container">
      <div className="scannel_tools-container_groupA">
        <ToolsCard imgUrl={subfinder} heading="Nuclei" data="Used to send requests across targets based on a template" />
      </div>
      <div className="scannel_tools-container_groupB">
        <ToolsCard imgUrl={whatweb} heading="Subdomain Finder" data="Finds associated subdomains in the organization" btn="" />
        <ToolsCard imgUrl={sql} heading="TCP Scan" data="Checks for any open TCP Port on your server" btn="" />
        <ToolsCard imgUrl={nuclei} heading="Whois" data="Check for Registry and Registrar and other domain details" btn="" />
        <ToolsCard imgUrl={blog04} heading="SQL Scan" data="Verify the vulnerability of websites SQL injection attacks" btn="" />
      </div>
    </div>
  </div>
  )
}



export default Tools
